export default __webpack_public_path__ + "static/media/ThinkPortal_app.61ade5e2.png";